module.exports = __webpack_public_path__ + "static/media/shark.35232486.png";